export const state = {
    showNav: false
}

export const mutations = {
    setNavigation(state) {
        state.showNav = !state.showNav
    }
}

export const actions = {
    async toggleNavigation({commit}) {
        commit('setNavigation')
    },
}

export default {
    state,
    actions,
    mutations,
};
